import { ScreenSize } from '../enum/screen-size.enum';
import { IDictionary } from '../interfaces/dictionary.interface';

export const RWD_BREAKPOINTS: IDictionary<{ from?: number; to?: number }> = {
    [ScreenSize.small]: { from: 0, to: 767 },
    [ScreenSize.medium]: { from: 768, to: 1023 },
    [ScreenSize.large]: { from: 1023 },
};
